import React, { Component } from "react";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonMenu,
  IonItem,
  IonList,
  IonMenuButton,
  IonButtons,
  IonIcon,
  IonButton,
  IonModal,
  isPlatform,
} from "@ionic/react";

import "../../Shared.css";
import "../../../App.css";
import "./MenuPage.css";

import { menuController } from "@ionic/core/components";

import { App } from "@capacitor/app";
import { Browser } from "@capacitor/browser";

import { IScreenProps, IUser } from "../../Interfaces";
import AppController from "../../../controllers/AppController";
import RemoteDataController from "../../controllers/RemoteDataController";

import AppHeader from "../../components/AppHeader";

import iconAccount from "../../assets/Button_Account@3x.png";
import iconAccountDark from "../../assets/Button_Account_Dark@3x.png";
import iconClose from "../../assets/Button_Close@3x.png";
import iconSettings from "../../assets/Button_Settings@3x.png";
import iconSettingsDark from "../../assets/Button_Settings_Dark@3x.png";
import iconInfo from "../../assets/Button_Info@3x.png";
import iconInfoDark from "../../assets/Button_Info_Dark@3x.png";
import iconContact from "../../assets/Button_Contact@3x.png";
import iconContactDark from "../../assets/Button_Contact_Dark@3x.png";
import iconSwitchAccount from "../../assets/Button_SwitchAccount@3x.png";
import iconSwitchAccountDark from "../../assets/Button_SwitchAccount_Dark@3x.png";
import iconTakeSurvey from "../../assets/Button_Take_Survey@3x.png";
import iconHelp from "../../assets/Button_Help@3x.png";
import iconHelpDark from "../../assets/Button_Help@3x.png";
import iconParaPass from "../../assets/Icon_ParaPass@3x.png";
import iconParaFolio from "../../assets/Icon_ParaFolio@3x.png";
import iconLink from "../../assets/Button_Link@3x.png";
import iconLinkDark from "../../assets/Button_Link_Dark@3x.png";

import SettingsPage from "../settings/SettingsPage";
import InfoPage from "../help/InfoPage";
import DataController from "../../controllers/DataController";

type Props = { screenProps: IScreenProps; features: string[] };
type State = {
  settingModalOpen: boolean;
  appInformationModalOpen: boolean;
  testModeCounter: number;
  appVersionText: string;
};

class MenuPage extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      settingModalOpen: false,
      appInformationModalOpen: false,
      testModeCounter: 0,
      appVersionText: "",
    };
  }

  async componentDidMount() {
    let appVersionText = await DataController.getAppVersion(this.props.screenProps.app);
    this.setState({ appVersionText });
  }

  menuButtonClicked(): void {
    menuController.toggle();
  }

  accountButtonClicked() {
    this.props.screenProps.showAccountModal(true);
    RemoteDataController.logEvent("open_menu_item", { name: "Account" });
  }

  switchAccount(event: any) {
    try {
      event.stopPropagation();
    } catch (error) {
      console.log(error);
    }

    this.props.screenProps.showAccountSwitcher(true);
    RemoteDataController.logEvent("open_menu_item", { name: "Switch Account" });
  }

  helpCentreButtonClicked() {
    this.props.screenProps.showHelpCentre();
    RemoteDataController.logEvent("open_menu_item", { name: "Help Centre" });
  }

  settingsButtonClicked() {
    this.setState({ settingModalOpen: true });
    RemoteDataController.logEvent("open_menu_item", { name: "Settings" });
  }

  appInformationButtonClicked() {
    this.setState({ appInformationModalOpen: true });
    RemoteDataController.logEvent("open_menu_item", { name: "App Information" });
  }

  surveyButtonClicked() {
    Browser.open({ url: "https://m3kh8cpcbse.typeform.com/to/CMFdopB5" });
    RemoteDataController.logEvent("open_menu_item", { name: "Plus Survery" });
  }

  contactUsButtonClicked() {
    this.props.screenProps.showContactPage();
    RemoteDataController.logEvent("open_menu_item", { name: "Contact Us" });
  }

  testModeToggleClicked() {
    if (this.state.testModeCounter < 4) {
      this.setState({ testModeCounter: this.state.testModeCounter + 1 });
    } else {
      this.props.screenProps.toggleTestMode();
      this.setState({ testModeCounter: 0 });
    }
  }

  render() {
    let accountName = "Account";
    if (this.props.screenProps.user != null && this.props.screenProps.user.email !== "") {
      accountName = this.props.screenProps.user.email;
    }

    let otherAppsLayout = [];

    if (this.props.screenProps.user != null) {
      if (
        this.props.screenProps.hideParaPassLinks === false &&
        DataController.hasParaPassSubscription(this.props.screenProps.user.subscriptions)
      ) {
        otherAppsLayout.push(
          <div
            key="ParaPass"
            className="menuOtherAppsAppContainer"
            onClick={this.props.screenProps.openParaPass.bind(this)}
          >
            <div className="menuOtherAppsAppFrontContainer">
              <img className="menuOtherAppsAppIcon" src={iconParaPass} alt="" />
              <div className="menuOtherAppsAppTitle">ParaPass</div>
            </div>
            <img
              className="menuOtherAppsOpenIcon"
              src={this.props.screenProps.darkMode ? iconLinkDark : iconLink}
              alt=""
            />
          </div>
        );
      }
      if (
        this.props.screenProps.hideParaPassLinks === false &&
        DataController.hasParaFolioSubscription(this.props.screenProps.user.subscriptions)
      ) {
        otherAppsLayout.push(
          <div
            key={"ParaFolio"}
            className="menuOtherAppsAppContainer"
            onClick={this.props.screenProps.openParaFolio.bind(this)}
          >
            <div className="menuOtherAppsAppFrontContainer">
              <img className="menuOtherAppsAppIcon" src={iconParaFolio} alt="" />
              <div className="menuOtherAppsAppTitle">ParaFolio</div>
            </div>
            <img
              className="menuOtherAppsOpenIcon"
              src={this.props.screenProps.darkMode ? iconLinkDark : iconLink}
              alt=""
            />
          </div>
        );
      }
    }

    return (
      <>
        <IonMenu
          side="start"
          menuId="first"
          content-id="main"
          swipe-gesture={false}
          disabled={false}
          maxEdgeStart={100}
          hidden={false}
          type="overlay"
        >
          <IonHeader translucent>
            <IonToolbar className="navBar">
              <IonButtons slot="start">
                <IonButton onClick={this.menuButtonClicked.bind(this)}>
                  <img className="icon-44" src={iconClose} />
                </IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent>
            <IonList lines="none" className="menuList">
              <div className="menuRow">
                <img alt="" className="icon-44" src={this.props.screenProps.darkMode ? iconAccountDark : iconAccount} />
                <span className="menuLabel" onClick={this.accountButtonClicked.bind(this)}>
                  {accountName}
                </span>
              </div>
              {this.props.screenProps.helpCentreItems.length > 0 ? (
                <div className="menuRow" onClick={this.helpCentreButtonClicked.bind(this)}>
                  <img alt="" className="icon-44" src={this.props.screenProps.darkMode ? iconHelpDark : iconHelp} />
                  <span className="menuLabel">Help centre</span>
                </div>
              ) : null}
              <div className="menuRow" onClick={this.settingsButtonClicked.bind(this)}>
                <img
                  alt=""
                  className="icon-44"
                  src={this.props.screenProps.darkMode ? iconSettingsDark : iconSettings}
                />
                <span className="menuLabel">Settings</span>
              </div>
              <div className="menuRow" onClick={this.contactUsButtonClicked.bind(this)}>
                <img
                  alt=""
                  className="icon-44 icon-padding"
                  src={this.props.screenProps.darkMode ? iconContactDark : iconContact}
                />
                <span className="menuLabel">Contact us</span>
              </div>
              <div className="menuRow" onClick={this.appInformationButtonClicked.bind(this)}>
                <img alt="" className="icon-44" src={this.props.screenProps.darkMode ? iconInfoDark : iconInfo} />
                <span className="menuLabel">App information</span>
              </div>
              <div className="menuRow" onClick={this.switchAccount.bind(this)}>
                <img
                  alt=""
                  className="icon-44"
                  src={this.props.screenProps.darkMode ? iconSwitchAccountDark : iconSwitchAccount}
                />
                <span className="menuLabel">Switch account</span>
              </div>
              {this.props.features.includes("showMenuSurvey") ? (
                <div className="menuRow" onClick={this.surveyButtonClicked.bind(this)}>
                  <img
                    alt=""
                    className="icon-44"
                    src={this.props.screenProps.darkMode ? iconTakeSurvey : iconTakeSurvey}
                  />
                  <span className="menuLabel">JRCALC Plus Survey</span>
                </div>
              ) : null}
            </IonList>

            {otherAppsLayout.length > 0 ? (
              <div className="menuOtherAppsContainer">
                <div className="menuOtherAppsTitle">Your other apps</div>
                {otherAppsLayout}
              </div>
            ) : null}
          </IonContent>

          <div className="testModeToggle" onClick={this.testModeToggleClicked.bind(this)}>
            {this.props.screenProps.testMode ? <div>Test mode enabled</div> : null}
          </div>

          <div className="menuAppVersionText" onClick={this.testModeToggleClicked.bind(this)}>
            {this.state.appVersionText}
          </div>
        </IonMenu>

        <IonModal isOpen={this.state.settingModalOpen} onDidDismiss={() => this.setState({ settingModalOpen: false })}>
          <SettingsPage
            close={() => this.setState({ settingModalOpen: false })}
            features={this.props.features}
            screenProps={this.props.screenProps}
          />
        </IonModal>

        <IonModal
          isOpen={this.state.appInformationModalOpen}
          onDidDismiss={() => this.setState({ appInformationModalOpen: false })}
        >
          <InfoPage
            close={() => this.setState({ appInformationModalOpen: false })}
            features={this.props.features}
            screenProps={this.props.screenProps}
          />
          <div className="appColorOverlay" />
        </IonModal>
      </>
    );
  }
}

export default MenuPage;
